var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleBrokenUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33944 14.5896C1.44852 11.2534 2.3117 7.54623 4.92899 4.92893C8.83424 1.02369 15.1659 1.02369 19.0711 4.92893C22.9764 8.83418 22.9764 15.1658 19.0711 19.0711C16.4538 21.6884 12.7467 22.5515 9.41051 21.6606M15.0002 15.0001V9.0001M15.0002 9.0001H9.0002M15.0002 9.0001L5.00001 19",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleBrokenUpRight);
export default __webpack_public_path__ + "static/media/arrow-circle-broken-up-right.fb3d5db2400c4d8fa38b457e7078cf3b.svg";
export { ForwardRef as ReactComponent };